import clsx from "clsx";
import { Link } from "react-router";
import { OpenChatConversation } from "@/types/open-chat";
import { useDateFormatter } from "@/hooks/useDateFormatter";

interface Props {
  selected: boolean;
  conversation: OpenChatConversation;
}

export const SidebarHistoryRow = ({ conversation, selected }: Props) => {
  const { formatRelative } = useDateFormatter();

  return (
    <Link
      to={`/open-chat/${conversation.id}`}
      className={clsx(
        "block cursor-pointer rounded-lg border border-input bg-white/80 p-3 transition-all hover:border-desert-sand-400 hover:bg-ivory-mist-100",
        {
          "border-desert-sand-400 bg-ivory-mist-100": selected,
        },
      )}
    >
      <p className="text-sm font-medium text-foreground">{conversation.name || "Unnamed conversation"}</p>
      <p className="mt-1 text-xs text-muted-foreground">{formatRelative(conversation.created_at)}</p>
    </Link>
  );
};
